import "./Activity.css"
import Check from "../../../../assets/iconos/check.png";
import Finish from "../../../../assets/LectureFinal.png";
import { useEffect, useState } from "react"
import { getActivityContent } from '../../../../Services/Content.js';
import { setActivityScore, setLectureScore } from '../../../../Services/Scores.js';
import { setLectureScoreView } from '../../../../Services/Lecture.js';


import CanvaFrame from "./Canva/CanvaFrame.jsx";
import VideoFrame from "./Video/VideoFrame.jsx";
import DownloadFrame from "./Download/DownloadFrame.jsx";
import QuestionFrame from "./Question/QuestionFrame.jsx";
import PostActivity from "./Post/PostActivity.jsx";
import DialogModal from "../../../Modals/dialogModal";


var current = 0;
const Activity = (props) => {


const [CurrentStage, setCurrentStage] = useState(1)
const [frame, setFrame] = useState(<></>);
const [idLoading, setIsLoading] = useState(true);
const [next, setNext] = useState(false);
const [allowed, setAllowed] = useState(0);
const [showModal, setShowModal] = useState(false)


const loadActualActivity = async () => {
    var rsp;


    if(props.activitiesId.data.length == current){
        setFrame(<></>);
    }else{
        rsp = await getActivityContent(props.activitiesId.data[current]);
    
        if(rsp.Error == false){
            {
                var exist = false;
                exist = props.activitiesId.scores.find((item) => item === props.activitiesId.data[current]);
                switch(rsp.Data.id_type){
                    case 1:{
                        setFrame(<CanvaFrame url={rsp.Data.url} setNext={setNext} />);

                        if(!exist){
                            await setActivityScore({score:'Finalizada', id:props.activitiesId.data[current]});
                            props.activitiesId.scores.push(props.activitiesId.data[current]);
                        }
                        break;
                    };
                    case 2:{
                        setFrame(<VideoFrame url={rsp.Data.url} Data={rsp.Data} setNext={setNext} idActivity={props.activitiesId.data[current]} setActivityScore={setActivityScore} exist={exist} scores={props.activitiesId.scores}/>);
                        break;
                    };
                    case 3:{
                        setFrame(<DownloadFrame url={rsp.Data.url} setNext={setNext}/>);
                        if(!exist){
                            await setActivityScore({score:'Finalizada', id:props.activitiesId.data[current]});
                            props.activitiesId.scores.push(props.activitiesId.data[current]);
                        }
                        break;
                    };
                    case 4:{
                        setFrame(<QuestionFrame question={rsp.Data.questions} idActivity={props.activitiesId.data[current]} setNext={setNext} setActivityScore={setActivityScore} exist={exist} scores={props.activitiesId.scores}/>);
                        break;
                    };
                    case 5:{
                        setFrame(<PostActivity content={rsp.Data.post} idActivity={props.activitiesId.data[current]} setNext={setNext} setActivityScore={setActivityScore} exist={exist} scores={props.activitiesId.scores}/>)
                        break;
                    }
                    default:{
                        setFrame(<div>
                                    <div className="canvaFrame">
                                    </div>
                                </div>
                        );
                    }
                }
            }
        }
    
        setIsLoading(false);
    }
}

function handleNextStage () {
    setIsLoading(true);
    setAllowed(allowed + 1);
    setNext(false);
    setCurrentStage(CurrentStage+1);
    current++;
    loadActualActivity();
}

function handlePrevStage () {
    setIsLoading(true);
    setCurrentStage(CurrentStage-1);
    current--;
    loadActualActivity();
}

function setNewStage (prop){

    if(allowed >= prop - 1){
        setIsLoading(true);
        setNext(false);
        setCurrentStage(prop);
        current = prop - 1;
        loadActualActivity();
    }else{
        setShowModal(true)
    }
}

const endActivity = async () => {

    if(!props.isFinished){
        let rsp = await setLectureScore({id:props.activitiesId.activityId, score:"Finalizado"});
        let rsp2 = await setLectureScoreView(props.activitiesId.lecture_id);



        if(rsp?.Error == false){
            props.setSubFrame('modulos');
        }
    }else{
        props.setSubFrame('modulos');
    }

}


useEffect(() => {
    loadActualActivity();
    current = 0;
    if(props.activitiesId.scores.length == 0){
        setAllowed(0);
        current = 0;
    }else{
        setAllowed(props.activitiesId.scores.length);
    }
}, [])

  return (
    <div className='frame'>
        <DialogModal showModal={showModal} setShowModal={setShowModal}>
            <h3>Tienes que finalizar las actividades anteriores antes de iniciar la siguiente.</h3>
        </DialogModal>
            <div className="activity-content-container">
                    <div className='ActivityStageContainer'>
                        <div className='ActivityStage'>
                            {props.activitiesId.data.map((item, index)=>(
                                <div key={item.id}>
                                    <div className={CurrentStage === index + 1 ? "stage-selector-active" : "stage-selector setpointer"} onClick={() => setNewStage(index + 1)}>
                                        <h2>
                                            {index + 1}
                                        </h2>
                                    </div>
                                </div>
                            ))}
                            <div className={CurrentStage === props.activitiesId.data.length + 1 ? "stage-selector-active" : "stage-selector"}><img src={Check} alt="" className={CurrentStage === props.activitiesId.data.length + 1 ? "check-icon" : "nodisplay"}/></div>
                        </div>
                    </div>
                    <div className="content-container">
                        {
                        idLoading ? 
                                <div className="canvaFrame downloadFrame">
                                    {
                                        CurrentStage === props.activitiesId.data.length + 1 ?
                                        <>
                                            <img src ={Finish} className="finishLectureImg"/>
                                            <button className="green-btn setpointer awnser-btn" onClick={endActivity}>Finalizar</button>
                                        </>
                                        :
                                        <></>
                                    }
                                </div>
                        : 
                            frame
                        }
                    </div>
                <div className='activity-control'>
                    {
                        CurrentStage === props.activitiesId.data.length + 1 ?
                        <></>
                        :
                        <button className={CurrentStage === 1 ? "nodisplay" : "green-btn setpointer next-btn"} onClick={() => handlePrevStage()}>Actividad Anterior</button>
                    }
                    {
                        next ? 
                        <button className={(CurrentStage === props.activitiesId.data.length + 1) ? "nodisplay" : "green-btn setpointer next-btn"} onClick={() => handleNextStage()}>{CurrentStage === props.activitiesId.data.length ? "Finalizar Actividad" : "Siguiente Actividad"}</button>
                        :
                        <></>
                    }
                </div>
            </div>
    </div>
  )
}

export default Activity